import React from 'react';
import PropTypes from 'prop-types';
import Radio from 'relements/build/esm/input/radio';

// Components
import Icon from 'components/Icon';

// Local
import styles from './EntityTypeCard.scss';

const EntityTypeCard = ({
  selected,
  iconType = 'entity-type-default',
  name,
  description = '',
  botText = null,
  userText = null, 
  onClick = null,
  entityType,
}) => {
  if (!name) {
    name = entityType;
  }

  const selectedValue = selected ? {entityType} : ''; 

  return (
    <div
      className={`${styles.container} ${selected ? styles.selected : ''}`}
      onClick={onClick}
    >
      <div className={styles.entitySelected}>
        <Radio options={[{ entityType }]} value={selectedValue} optionKey="entityType" />
      </div>

      <div className={styles.entityIcon}>
        <Icon iconType={iconType} size={24} />
      </div>
      <div className={styles.entityDetails}>
        <div className={styles.name}> {name} </div>
        <div className={styles.description}> {description} </div>
      </div>
      <div className={styles.example}>
        {botText && userText && (
          <React.Fragment>
            Example:
            <div className={styles.exampleText}> Bot: {botText} </div>
            <div className={styles.exampleText}> User: {userText} </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

EntityTypeCard.propTypes = {
  entityType: PropTypes.string,
  selected: PropTypes.bool,
  iconType: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  botText: PropTypes.string,
  userText: PropTypes.string,
  onClick: PropTypes.func,
};

export default EntityTypeCard;
